var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaigns({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campaigns",
    transform: "translate(-138 -45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8623",
    "data-name": "Rectangle 8623",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(138 45)",
    fill: "#404246"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DQow3Y.tif",
    transform: "translate(3107.239 -944.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17242",
    "data-name": "Group 17242",
    transform: "translate(-2959.446 999.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30463",
    "data-name": "Path 30463",
    d: "M-2825.715,1006.984q0,3.1,0,6.21a1.073,1.073,0,0,1-.606,1.041.934.934,0,0,1-1-.037c-1.38-.853-2.757-1.712-4.161-2.524a14.313,14.313,0,0,0-3.9-1.544c-.195-.046-.237-.13-.237-.313q.007-2.9,0-5.8c0-.119-.011-.221.152-.266a24.736,24.736,0,0,0,5.548-2.589c.867-.492,1.759-.938,2.62-1.439a1.106,1.106,0,0,1,1.588,1C-2825.729,1002.808-2825.715,1004.9-2825.715,1006.984Z",
    transform: "translate(2842.378 -999.598)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30464",
    "data-name": "Path 30464",
    d: "M-2953.831,1078.874v6c-.889,0-1.749,0-2.608,0a3.012,3.012,0,0,1-.567-.055,3.017,3.017,0,0,1-2.438-2.992,2.969,2.969,0,0,1,2.655-2.935C-2955.827,1078.8-2954.849,1078.874-2953.831,1078.874Z",
    transform: "translate(2959.446 -1074.521)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30465",
    "data-name": "Path 30465",
    d: "M-2891.779,1210.883h1.9c.148.558.269,1.1.441,1.634a4.014,4.014,0,0,0,1.055,1.689.491.491,0,0,1,.163.511c-.086.361-.144.728-.222,1.09-.095.437-.369.538-.731.265a6.139,6.139,0,0,1-1.908-2.467A8.991,8.991,0,0,1-2891.779,1210.883Z",
    transform: "translate(2895.473 -1199.348)",
    fill: "#f8f8f8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.ca822a01966f58d52cae2b99c6622d7c.svg";
export { ForwardRef as ReactComponent };